import { printFileSize } from "@mirage/utilities/FileSizeCalculator";
import { IAttachmentThumbnail } from "@shared/mirage/core/contracts/IAttachment";
import { useMemo } from "react";

export const DocumentsTableFileSizeCell: React.FC<{ val: IAttachmentThumbnail | undefined }> = ({ val }) => {
    const fileSize = useMemo(() => printFileSize(Number(val)), [val]);
    return <>{fileSize}</>;
};
